import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import moment from 'moment';
import 'moment/locale/fr-ca';
import debounce from 'utils/debounce';

import YearMonthNav from './YearMonthNav';
import DatePickerInput from './DatePickerInput';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import * as MomentLocaleUtils from 'react-day-picker/moment';

import 'react-day-picker/lib/style.css';
import './DatePicker.scss';

@observer
export default class DatePicker extends Component {
	static propTypes = {
		id: PropTypes.string,
		onChange: PropTypes.func.isRequired,
		selected: PropTypes.string.isRequired,
		format: PropTypes.string,
		disabled: PropTypes.bool,
		disabledDays: PropTypes.array,
		locale: PropTypes.string,
	};

	static defaultProps = {
		id: '',
		disabled: false,
		format: 'L',
		disabledDays: [],
		locale: 'en-US',
	};

	@observable month = moment(this.props.selected, this.props.format).toDate();

	@debounce
	onChange(date, modifiers, dayPickerInput) {
		const value = date
			? moment(date).format(this.props.format)
			: dayPickerInput.getInput().props.value;

		this.props.onChange(value);
	}

	@action
	handleYearMonthChange(month) {
		this.month = month;
	}

	render() {
		return (
			<DayPickerInput
				disabled={this.props.disabled}
				component={DatePickerInput}
				value={this.props.selected}
				formatDate={MomentLocaleUtils.formatDate}
				parseDate={MomentLocaleUtils.parseDate}
				format={this.props.format}
				placeholder={''}
				inputProps={{
					className: 'form-control',
					id: this.props.id,
				}}
				onDayChange={this.onChange.bind(this)}
				dayPickerProps={{
					localeUtils: MomentLocaleUtils,
					locale: this.props.locale,
					month: this.month,
					pagedNavigation: true,
					canChangeMonth: true,
					disabledDays: this.props.disabledDays,
					enableOutsideDays: true,
					captionElement: (
						<YearMonthNav onChange={this.handleYearMonthChange.bind(this)} />
					),
				}}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/DatePicker/index.js